import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Dashboard } from 'services/action';
import _ from 'underscore';
import { Page, DatePicker } from 'ui/components';
import { Skeletons } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';
import * as Section from './component';

const initialState = {
  filter: {
    date: new Date(),
    format: formatDate(new Date(), 'YYYY-MM'),
  },
  data_manifest: null,
  data_shipment: null,
  loading: true,
  privileges: null,
};

const DashboardScreen = () => {
  const Dispatch = useDispatch();
  const ManifestLoading = useSelector(
    (state) => state?.Activity?.services['Dashboard.Manifest']
  );
  const ShipmentLoading = useSelector(
    (state) => state?.Activity?.services['Dashboard.Order']
  );
  const Session = useSelector((state) => state.Auth?.session);

  const [
    { filter, data_manifest, data_shipment, loading, privileges },
    setState,
  ] = React.useState(initialState);

  const $onLoad = async (e) => {
    const payload = {};

    if (e) {
      payload.monthly = e;
    }

    if (!Session?.privileges || privileges?.manifest) {
      const res = await Dispatch(Dashboard.$manifest(payload));
      if (res?.message === 'success') {
        setState((prevState) => ({ ...prevState, data_manifest: res?.data }));
      }
    }

    if (!Session?.privileges || privileges?.delivery) {
      const result = await Dispatch(Dashboard.$order(payload));
      if (result?.message === 'success') {
        setState((prevState) => ({
          ...prevState,
          data_shipment: result?.data,
        }));
      }
    }
  };

  const $getPriviledge = async () => {
    const payload = {};

    const findDelivery = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.delivery',
    });

    const findManifest = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });

    if (findDelivery) {
      payload.delivery = findDelivery;
    }

    if (findManifest) {
      payload.manifest = findManifest;
    }

    setState((prevState) => ({
      ...prevState,
      privileges: payload,
    }));
  };

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, loading: true }));
    $onLoad(filter?.format);
    setState((prevState) => ({ ...prevState, loading: false }));
  }, [filter, privileges]);

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  React.useEffect(() => {
    if (filter?.date) return;

    setState((prevState) => ({
      ...prevState,
      filter: { date: new Date(), format: formatDate(new Date(), 'YYYY-MM') },
    }));
  }, [filter]);

  return (
    <Fragment>
      <Page>
        <Page.Header
          pretitle=""
          title="Dashboard"
          isLoading={loading}
          action={
            privileges?.delivery?.action === 'manage' || !Session?.privileges
              ? { url: '/order/create', text: 'Buat Order Baru' }
              : null
          }
        >
          {loading ? (
            <Skeletons height="30px" width="250px" />
          ) : (
            <DatePicker
              selectionMode="month"
              value={filter?.date}
              onChange={(date) => {
                setState((prevState) => ({
                  ...prevState,
                  filter: { date: date, format: formatDate(date, 'YYYY-MM') },
                }));
              }}
              isShowTrigger={true}
            />
          )}
        </Page.Header>
        <Page.Body className="bg-light p-3 pt-0 mt-3 mt-md-0">
          {(!Session?.privileges || privileges?.delivery) && (
            <div className="row mb-0 mb-md-3">
              <div className="col-md-7 mb-3 mb-md-0">
                <Section.CardMap filter={filter} />
              </div>
              <div className="col-md-5 mb-3 mb-md-0">
                <Section.CardStatisticShipment
                  isLoading={ShipmentLoading}
                  data={data_shipment?.shipment_statistic}
                  graph={data_shipment?.shipment_graph_daily_service}
                />
              </div>
            </div>
          )}
          <div className="row mb-3 mb-md-0">
            {(!Session?.privileges || privileges?.manifest) && (
              <>
                <div className="col-md-2">
                  <Section.CardStatisticManifest
                    isLoading={ManifestLoading}
                    data={data_manifest?.manifest_statistic}
                  />
                </div>
                <div
                  className={`${
                    !Session?.privileges || privileges?.delivery
                      ? 'col-md-6'
                      : 'col-md-10'
                  }`}
                >
                  <Section.CardManifest
                    isLoading={ManifestLoading}
                    data={data_manifest?.manifests}
                  />
                </div>
              </>
            )}
            {(!Session?.privileges || privileges?.delivery) && (
              <div
                className={`${
                  !Session?.privileges || privileges?.manifest
                    ? 'col-md-4'
                    : 'col-md-12'
                }`}
              >
                <Section.CardShipment
                  isLoading={ShipmentLoading}
                  data={data_shipment?.shipment_not_dispatch}
                />
              </div>
            )}
          </div>
        </Page.Body>
      </Page>
    </Fragment>
  );
};

export default DashboardScreen;
